import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { RouterModule } from '@angular/router';
import { UploadFileInputComponent } from './components/upload-file-input/upload-file-input.component';
import { AddVideoModalComponent } from './components/add-video-modal/add-video-modal.component';
import { FormsModule } from '@angular/forms';
import { ObjectDialogRecapComponent } from './components/object-dialog-recap/object-dialog-recap.component';
import { UploadPictureInputComponent } from './components/upload-picture-input/upload-picture-input.component';
import { ShowPictureBase64ModalComponent } from './components/show-picture-base64-modal/show-picture-base64-modal.component';
import { EditGlobalTranslationModalComponent } from './components/edit-global-translation-modal/edit-global-translation-modal.component';
import { ButtonGlobalTranslationComponent } from './components/button-global-translation/button-global-translation.component';
import { MapGetPointComponent } from './components/map-get-point/map-get-point.component';
import { CreateFamilyValidatorComponent } from './validators/create-family-validator/create-family-validator.component';
import { ChatComponent } from './components/chat/chat.component';
import { AddDocumentModalComponent } from './components/add-document-modal/add-document-modal.component';
import { ListDocumentsComponent } from './components/list-documents/list-documents.component';
import { MinutesHumanisePipe } from '../pipes/minutes-humanise.pipe';

@NgModule({
    declarations: [
        ConfirmationDialogComponent,
        PageHeaderComponent,
        UploadFileInputComponent,
        AddVideoModalComponent,
        ObjectDialogRecapComponent,
        UploadPictureInputComponent,
        ShowPictureBase64ModalComponent,
        EditGlobalTranslationModalComponent,
        ButtonGlobalTranslationComponent,
        MapGetPointComponent,
        CreateFamilyValidatorComponent,
        ChatComponent,
        AddDocumentModalComponent,
        ListDocumentsComponent,
        MinutesHumanisePipe
    ],
    imports: [
        CommonModule,
        TranslateModule,
        FontAwesomeModule,
        NgbModule,
        RouterModule,
        FormsModule
    ],
    exports: [
        TranslateModule,
        FontAwesomeModule,
        ConfirmationDialogComponent,
        PageHeaderComponent,
        UploadFileInputComponent,
        AddVideoModalComponent,
        UploadPictureInputComponent,
        ShowPictureBase64ModalComponent,
        EditGlobalTranslationModalComponent,
        ButtonGlobalTranslationComponent,
        MapGetPointComponent,
        ChatComponent,
        AddDocumentModalComponent,
        ListDocumentsComponent,
        MinutesHumanisePipe
    ],
    providers: [DatePipe],
})


export class SharedModule {
    constructor(private library: FaIconLibrary) {
        // Ajoute toute la bibliothèque FontAwesome Solid
        this.library.addIconPacks(fas);
    }
}
